
export default function DaoPage() {
  return(
    <div className='main-container al-v'>
      <h1 style={{textAlign:"center"}}>Coming Soon...</h1>
    </div>
  )
}